import { NbMenuItem } from '@nebular/theme';

let idioma: String = "";
let menu_title: string = "";
let estoyLogueado: String = "";


if(localStorage.getItem("idioma") == null || localStorage.getItem("idioma") == undefined){

  idioma = 'es'

}else{

  idioma = localStorage.getItem("idioma")

}
estoyLogueado = sessionStorage.getItem("logueado")

if(idioma == "es" && estoyLogueado == "true"){
    menu_title = 'INSTALACIONES'
}else if(idioma == "en" && estoyLogueado == "true"){
    menu_title = 'INSTALATIONS'
}else if(idioma == "fr" && estoyLogueado == "true"){
    menu_title = 'INSTALLATIONS'
}else if(idioma == "it" && estoyLogueado == "true"){
    menu_title = 'STRUTTURE'
}


export const MENU_ITEMS: NbMenuItem[] = [

  {
    title: menu_title,
    link: '/pages/home',
    home: true,
  }
];


export let menu_dynamic: NbMenuItem[] = [];


export function setMenu(modules: NbMenuItem[]): void {
  // CONSTRUYE EL MENÚ A PARTIR DE UN VECTOR
  clearMenu();
  modules.forEach( (element) => {
    menu_dynamic.push(element);
  });
}


export function clearMenu(): void {
  menu_dynamic.length = 0;
}




